export default {
    mixins: [],
    data() {
        return {
            englishDoc: false,
            docTypeNums: 1,
            docTypeString: '',
        }
    },
    computed: {},
    mounted() {},
    beforeDestroy() {},
    watch: {},
    methods: {
        docModel() {
            if (this.$route.path.includes('endoc') === true) {
                this.docTypeNums = 1;
                this.docTypeString = 'AI识别';
                this.englishDoc = true;
            } else if (this.$route.path.includes('cedoc') === true) {
                this.docTypeNums = 2;
                this.docTypeString = 'AI识别';
                this.englishDoc = false;
            } else {
                this.docTypeNums = 3;
                this.docTypeString = 'AI识别';
            }
            this.$store.dispatch('setdocTypeNum', this.docTypeNums);
        }
    }
}